import * as React from 'react';
import { getShopSearchResults, getSelectedSearchedShop } from 'modules/search/shopsearchresults';
import { IShopSearchResultsAction, IShopSearchResultsData } from 'models/search/shopsearchresults';
import { IStore } from 'redux/IStore';
import { IShopListItem } from 'models/shop/shoplistitem';
import { ItemCardList, NoResults } from 'components';
import { ErrorPage } from 'containers';
import { IInfiniteScrollProps } from 'models/infinitescroll';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IUserLanguage } from 'models/user/userlanguage';
import { ResultsWrapper } from 'components/PortalStructure';
import { IItemCardList } from 'models/itemcard';
import { IUserPreferences } from 'models/user/userpreferences';
import { getNextPageCount } from 'helpers/common';
import { followShop, unfollowShop } from 'redux/modules/shop/shopcard';
import { IFollowerDto } from 'models/common';
import { getFollowingOrFollowersButtonsData } from 'redux/modules/user/usercard';
import { IFollowCardItem } from 'models/verticalwidgetcards/followcard';
import { browserHistory } from 'react-router';
const { connect } = require('react-redux');

interface IProps {
	shopSearchResultsData?: IShopSearchResultsData;
	userLanguage?: IUserLanguage;
	getShopSearchResults?: Redux.ActionCreator<IShopSearchResultsAction>;
	getSelectedSearchedShop?: Redux.ActionCreator<IShopSearchResultsAction>;
	showHeaderCloseButton?: boolean;
	userPreferences?: IUserPreferences;
	followItem?: (itemId: string, items: IFollowCardItem[]) => void;
	unfollowItem?: (itemId: string, items: IFollowCardItem[]) => void;
	followingItems?: IFollowerDto[];

	selectShop?: (pickerData?: IShopListItem) => void;
	t?: (key: string) => string;
}

@connect(
	(state: IStore) => ({
		shopSearchResultsData: state.shopSearchResults,
		fetchDefault: state.fetchDefault,
		userLanguage: state.userLanguage,
		userPreferences: state.userPreferences,
		followingItems: state.usercard.followingItems || [],
	}),
	(dispatch) => {
		const loadFollowing = (items: IFollowCardItem[]) =>
			dispatch(getFollowingOrFollowersButtonsData(items, true, false));
		return {
			getShopSearchResults: (isFirstLoad: boolean, keyword: string) =>
				dispatch(getShopSearchResults(isFirstLoad, keyword)),
			getSelectedSearchedShop: (id: string) => dispatch(getSelectedSearchedShop(id)),
			followItem: (id: string, items: IFollowCardItem[]) => dispatch(followShop(id, () => loadFollowing(items))),
			unfollowItem: (id: string, items: IFollowCardItem[]) => dispatch(unfollowShop(id, () => loadFollowing(items))),
		};
	},
)
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopSearchResults extends React.Component<IProps, any> {
	private selectedShopId = '';
	private searchShopsValue = '';

	constructor(props) {
		super(props);

		this.selectedShopId = '';
		this.searchShopsValue = '';

		this.onSubmit = this.onSubmit.bind(this);
		this.onShopIdChange = this.onShopIdChange.bind(this);
		this.loadMoreData = this.loadMoreData.bind(this);
		this.onSearchShopsValueChange = this.onSearchShopsValueChange.bind(this);
		this.searchShops = this.searchShops.bind(this);
		this.goToShopById = this.goToShopById.bind(this);
	}

	public loadMoreData() {
		this.props.getShopSearchResults(false, this.props.shopSearchResultsData.lastSearchedKeyword);
	}

	public onSubmit() {
		if (!this.selectedShopId) {
			alert(this.props.t('SearchShops_Validation'));
			return;
		}
		this.props.selectShop(this.props.shopSearchResultsData.selectedSearchedShop);
	}

	private onShopIdChange(event: any) {
		this.selectedShopId = event.target.value;
		this.props.getSelectedSearchedShop(this.selectedShopId);
		this.forceUpdate();
	}

	private onSearchShopsValueChange(e: any) {
		const value: string = e.target.value;
		this.searchShopsValue = value.length > 0 ? value : null;
		this.forceUpdate();
	}

	private searchShops() {
		this.props.getShopSearchResults(true, this.searchShopsValue);
	}
	private goToShopById(id: string) {
		if (!id) {
			return;
		}
		const { items } = this.props.shopSearchResultsData;
		const shop = items.find((i) => i.entityId === id);
		if (!shop) {
			return;
		}
		browserHistory.push('/shop/' + shop.code);
	}

	public render() {
		if (this.props.shopSearchResultsData.error) {
			return <ErrorPage {...this.props} message={this.props.shopSearchResultsData.message} />;
		}
		const { items, itemsPage, isFetching } = this.props.shopSearchResultsData;
		const { t, userPreferences } = this.props;

		const nextPageItems = getNextPageCount(itemsPage, items.length);

		const infiniteScrollProps: IInfiniteScrollProps = {
			dataLength: items.length,
			next: this.loadMoreData,
			hasMore: nextPageItems > 0,
			loader: <h4>{t('BSPortal_Common_Loading')}</h4>,
		};

		const listProps: IItemCardList = {
			items,
			itemType: c.NODE_TYPE_SHOP_ITEM_CARD,
			isInfiniteScroll: true,
			infiniteScrollProps,
			followItem: (_: string, id: string) => this.props.followItem(id, items),
			unfollowItem: (_: string, id: string) => this.props.unfollowItem(id, items),
			followingItems: this.props.followingItems,
			currentUserId: userPreferences.id,
			isFetching,
			loadingText: t('BSPortal_Common_Loading'),
			noResults: <NoResults t={t} />,
			nextPageItems,
			goToCard: this.goToShopById,
		};

		return (
			<ResultsWrapper>
				<ItemCardList {...listProps} />
			</ResultsWrapper>
		);
	}
}

export { ShopSearchResults };
